<table class="custom-event-editor" width="100%" cellpadding="5">
    <tbody>
        <tr *ngIf="myWorktimesService.canUserRemoveEveryWorktime">
            <td class="e-textlabel">
                {{ 'supplier-regions.choose-region' | translate }}
            </td>
            <td colspan="4">
                <app-supplier-region-chooser
                    (onSelect)="setSupplierRegion($event)"
                    [selectedRegionID]="currentSupplierRegionID"
                    id="worktime-supplier-region-list"
                >
                </app-supplier-region-chooser>
            </td>
        </tr>
        <tr>
            <td class="e-textlabel">{{ 'my-worktime.worktime-from' | translate }}</td>
            <td colspan="4">
                <input id="StartTime" class="e-field" type="text" name="StartTime" />
            </td>
        </tr>
        <tr>
            <td class="e-textlabel">{{ 'my-worktime.worktime-to' | translate }}</td>
            <td colspan="4">
                <input id="EndTime" class="e-field" type="text" name="EndTime" />
            </td>
        </tr>
    </tbody>
</table>
